import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ShoppingCartDto } from 'src/app/core/dtos/dto';

@Component({
  selector: 'app-order-items',
  templateUrl: './order-items.component.html',
  styleUrls: ['./order-items.component.scss']
})
export class OrderItemsComponent implements OnInit {

  @Input() shoppingCart: ShoppingCartDto;
  @Output() applyDiscount: EventEmitter<string> = new EventEmitter<string>();

  discountCode: string;

  constructor() { }

  ngOnInit(): void {
  }

  applyDiscountCode() {
    this.applyDiscount.emit(this.discountCode);
  }

}
